import { LmiContractConfig, QualificationType } from './types';

export const maLmiContractConfig: LmiContractConfig = {
  title: 'Check if you qualify for income-based savings',
  description:
    'You may qualify for additional savings if your household income falls below a certain limit or if you participate in a qualifying low-to-moderate income (LMI) program.',
  lmiProofCategory: 'qualifying_programs',

  fields: [
    {
      name: 'county',
      type: 'select',
      label: 'County',
      required: false,
      placeholder: 'Select county',
    },
    {
      name: 'householdOccupancy',
      type: 'select',
      label: 'Household occupancy',
      required: true,
      placeholder: 'Select an option',
    },
    {
      name: 'qualifyingProgram',
      type: 'select',
      label: 'Select qualifying program (if applicable)',
      required: false,
      placeholder: 'Select program',
    },
    {
      name: 'qualificationType',
      type: 'radio',
      label: 'Please select one of the options below:',
      required: true,
      header: 'Household income limit',
      description:
        "Based on your household size, your household's gross annual income limit is {incomeLimit}.",
      interpolations: {
        incomeLimit: {
          source: 'variable',
          variableName: 'incomeLimit',
        },
      },
      options: [
        {
          value: QualificationType.INCOME,
          label:
            "I, {customerName} attest that my household's gross annual income qualifies as meeting the definition of a low income customer under the SMART program. ",
          enableWhen: {
            allOf: ['county', 'householdOccupancy'],
          },
          interpolations: {
            incomeLimit: {
              source: 'variable',
              variableName: 'incomeLimit',
            },
            customerName: {
              source: 'variable',
              variableName: 'customerName',
            },
          },
        },
        {
          value: QualificationType.PROGRAM,
          label:
            'I, {customerName}, attest that the Qualifying Program which I participate in or receive benefits from is: {programName}.',
          enableWhen: {
            allOf: ['householdOccupancy', 'qualifyingProgram'],
          },
          interpolations: {
            programName: {
              source: 'field',
              fieldName: 'qualifyingProgram',
            },
            customerName: {
              source: 'variable',
              variableName: 'customerName',
            },
          },
        },
      ],
      disclaimer: [
        'I acknowledge that the information on this form will only be used for the purposes of determining my eligibility as a low income customer. This form will be distributed and retained by the DOER and will only be shared within the DOER or its designee.',
        'I understand that the information provided on this form may be subject to verification at any time, and upon request, I may be requested to provide documentation to support the household income or Qualifying Program participation to which I have attested above.',
        'In signing this document, I declare that all information listed is complete and accurate',
      ],
      disclaimerStyle: {
        fontSize: '14px',
        fontWeight: 400,
        color: 'secondary',
        fontStyle: 'italic',
      },
    },
  ],

  contractLink: {
    preText: 'I have reviewed my',
    postText: '. By proceeding, I will be submitting my e-signature on the',
  },
};
